<button id="editContactModalBtn_{{key || ''}}" [attr.data-target]="'#editContactModal_' + (key || '')" data-toggle="modal" class="btn d-none"></button>
<div class="modal fade" id="editContactModal_{{key || ''}}" data-backdrop="static" tabindex="-1" role="dialog" [attr.aria-labelledby]="'editContactModalLabel_' + (key || '')" data-keyboard="false">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
        <div class="modal-content">
            <div class="modal-body">
                <section class="header">
                    <div class="flexed">
                        <span class="material-icons">{{icon}}</span>
                        <div class="meta">
                            <h2>{{display}}</h2>
                            <p class="subtitle">{{contact ? contact.roles : ''}}</p>
                        </div>
                    </div>
                    <form [formGroup]="form">
                        <div class="form-row">
                            @if (individual) {
                                <div class="col">
                                    <div class="input-group input-group-sm">
                                        <input type="date" class="form-control form-control-sm" formControlName="dob" />
                                        <div class="input-group-append"><span class="input-group-text">dob</span></div>
                                    </div>
                                </div>
                            }
                            <div class="col">
                                <div class="input-group input-group-sm">
                                    <div class="input-group-prepend"></div>
                                    <input type="password" id="contact-tax-id" class="form-control form-control-sm" formControlName="taxId" placeholder="{{individual ? 'SSN' : 'tax identity'}}" />
                                    @if (individual) {
                                        <div class="input-group-append clickable" (click)="toggleReveal($event)"><span class="input-group-text">{{lastFour}}</span> <span class="input-group-text material-icons-outlined">visibility</span></div>
                                    }
                                    @else {
                                        <div class="input-group-append clickable" (click)="toggleReveal($event)"><span class="input-group-text material-icons-outlined">visibility</span></div>
                                    }
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
                <div class="row row-cols-1 row-cols-lg-2">
                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">addresses</h5>
                                <addresses-compact [contactId]="contactId" [language]="language" [words]="words" (modified)="contactModified($event)"></addresses-compact>
                            </div>
                        </div>
                    </div>

                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">communications</h5>
                                <communications-compact [contactId]="contactId" [language]="language" [words]="words" (modified)="contactModified($event)"></communications-compact>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row row-cols-1 row-cols-lg-2">
                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">identifications</h5>
                                <identifications-compact [contactId]="contactId" [language]="language" [words]="words" (modified)="contactModified($event)"></identifications-compact>
                            </div>
                        </div>
                    </div>

                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">incomes</h5>
                                <incomes-compact [contactId]="contactId" [language]="language" [words]="words" (modified)="contactModified($event)"></incomes-compact>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-dismiss="modal"><span>Done</span></button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
